export default "__VITE_ASSET__DE8VsGzU__"